<template>
  <div class="animated fadeIn">
    <b-modal v-model="showCustomDomainModal" hide-footer>
      <p>{{this.customDomainMessage}}</p>
      <b-row>
        <b-col>
          <b-button class="mt-3 bg-sucess" block @click="showCustomDomainModal = false">Entendi</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-model="showRemovePageModal" hide-footer>
      <p>Se você apagar a página não será possível recuperá-la.</p>
      <b-row>
        <b-col>
          <b-button class="mt-3 bg-danger" block @click="removePage(pageToRemove)">Apagar Página</b-button>
        </b-col>
        <b-col>
          <b-button class="mt-3 bg-sucess" block @click="showRemovePageModal = false">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-alert variant="danger" show v-if="errorMessage">{{errorMessage}}</b-alert>
    <b-card v-if="loaded">
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col md="1" cols="2">
                <b-row>
                  <b-col cols="11" class="text-center" style="background-color: #82d0f5; color: white;">
                    <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_link.png" style="max-width: 25px;"></h4>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
                <h4 style="margin-top: 10px; margin-bottom: 10px;">Link do seu Site</h4>
              </b-col>
            </b-row>
            <b-row style="margin-top: 15px;">
              <b-col md="11" cols="10" offset-md="1" offset="2" style="padding-left: 0px;">
                Escolha o link do seu site. Apenas letras e números. Sem espaços pontos ou outros caracteres especiais.
                <b-row style="margin-top: 10px;">
                  <b-col cols="12">
                    <div class="float-left site" style="margin-top: 5px;">https://sites.sleeker.com.br/</div>
                    <div class="float-left" style="margin-left: 5px; width: 40%;">
                      <b-input style="background-color: #ddf2fc; width: 100%;" v-model="siteConfiguration.slug"></b-input>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="desktop" style="margin-top: 30px;">
                  <b-col cols="12" class="desktop text-center">
                    <img src="/site/img/icone_dominiopersonalizado.png" style="max-width: 40px;">
                  </b-col>
                  <b-col cols="12" class="text-center">
                    <b-button pill class="shadow desktop" @click="customDomainAction" style="background-color: #5a9dbd; color: white;">Quero usar um domínio personalizado</b-button>
                    <b-button pill class="shadow mobile" @click="customDomainAction" style="background-color: #5a9dbd; color: white;">Quero usar um domínio personalizado</b-button>
                    <p>Ex.: www.seunome.com.br</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" style="margin-top: 10px;">
            <b-row>
              <b-col md="1" cols="2">
                <b-row>
                  <b-col sm="11" class="text-center" style="background-color: #82d0f5; color: white;">
                    <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_contato.png" style="max-width: 25px;"></h4>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
                <h4 style="margin-top: 10px; margin-bottom: 10px;">Dados de Contato</h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <b-row>
              <b-col md="11" cols="10" offset-md="1" offset="2" style="padding-left: 0px;">
                Coloque aqui o seu Instagram, sem @ ou espaços, apenas o nome de usuário
              </b-col>
            </b-row>
            <b-row>
              <b-col md="1" cols="2" class="text-right">
                <img src="/site/img/icones_instagram.png" style="max-width: 30px;">
              </b-col>
              <b-col sm="11" cols="10" style="padding-left: 0px;">
                <b-input style="background-color: #ddf2fc" placeholder="nomedeusuariodoinstagram" v-model="siteConfiguration.instagram"></b-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col md="11" cols="10" offset-md="1" offset="2" style="padding-left: 0px;">
                Coloque aqui seu número de WhatsApp com DDD
              </b-col>
            </b-row>
            <b-row>
              <b-col md="1" cols="2" class="text-right">
                <img src="/site/img/icone_whatsapp.png" style="max-width: 30px;">
              </b-col>
              <b-col md="11" cols="10" style="padding-left: 0px;">
                <b-input style="background-color: #ddf2fc" placeholder="81999999999" v-model="siteConfiguration.whatsapp"></b-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12">
            <b-row>
              <b-col md="11" cols="10" offset-md="1" offset="2" style="padding-left: 0px;">
                Coloque aqui seu email de contato
              </b-col>
            </b-row>
            <b-row>
              <b-col md="1" cols="2" class="text-right">
                <img src="/site/img/icone_mail.png" style="max-width: 30px;">
              </b-col>
              <b-col md="11" cols="10" style="padding-left: 0px;">
                <b-input style="background-color: #ddf2fc" placeholder="seuemail@seuemail.com" v-model="siteConfiguration.email"></b-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" style="margin-top: 10px;">
            <b-row>
              <b-col md="1" cols="2">
                <b-row>
                  <b-col sm="11" class="text-center" style="background-color: #82d0f5; color: white;">
                    <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_integracao.png" style="max-width: 25px;"></h4>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
                <h4 style="margin-top: 10px; margin-bottom: 10px;">Integração com outras plataformas (ex.: Facebook Pixel, Google Ads, Google Analytics, etc.)</h4>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
              <b-col md="11" offset-md="1" cols="10" offset="2" style="padding-left: 0px;">
                  <textarea
                  class="form-control"
                  id="textarea-input"
                  name="textarea-input"
                  rows="10"
                  style="overflow-y: auto; max-height: 140px !important; background-color: #ddf2fc;"
                  placeholder="Cole aqui o código de integração"
                  v-model="siteConfiguration.metaData"
                ></textarea>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" style="margin-top: 10px;">
            <b-row>
              <b-col md="1" cols="2">
                <b-row>
                  <b-col sm="11" class="text-center" style="background-color: #82d0f5; color: white;">
                    <h4 style="margin-top: 10px; margin-bottom: 10px;"><img src="/site/img/icone_paginasdosite.png" style="max-width: 25px;"></h4>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="11" cols="10" style="background-color: #82d0f5; color: white;">
                <h4 style="margin-top: 10px; margin-bottom: 10px;">Páginas do Site</h4>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12">
            <b-row style="margin-top: 10px;">
              <b-col md="11" cols="10" offset-sm="1" offset="2" class="text-md-left text-center" style="padding-left: 0px; margin-top: 10px;" v-for="page in pages" :key="page._id">
                <img v-if="getThumbnail(page)" :src="getThumbnail(page)" style="max-width: 100px;"/>
                <p v-else>Você ainda não escolheu um layout para esta página.</p>
                <b-input style="background-color: #ddf2fc" :value="'https://sites.sleeker.com.br/' + siteConfiguration.slug + '/'+ page.slug"></b-input>
                <br/>
                <b-button class="shadow" style="background-color: #5a9dbd; color: white;" v-if="page._id == siteConfiguration.defaultPage" disabled>Esta é a página padrão</b-button>
                <b-button class="shadow" style="margin-left: 5px; background-color: #fda804; color: white;" v-else-if="getThumbnail(page)" @click="changeDefaultPage(page)">Tornar página padrão</b-button>
                <b-button class="shadow" style="margin-left: 5px; background-color: #77c365; color: white;" @click="editPage(page)">Editar</b-button>
                <b-button class="shadow" style="margin-left: 5px; background-color: #f00e23; color: white;" v-if="page._id != siteConfiguration.defaultPage" @click="removePageAction(page)">Remover</b-button>
                <b-button class="shadow" style="margin-left: 5px; background-color: #5a9dbd; color: white;" @click="previewPage(page)" v-if="getThumbnail(page)">Visualizar</b-button>
              </b-col>
              <b-col sm="8" offset-sm="1" v-if="pages && pages.length < 5" style="padding-left: 0px; margin-top: 20px;">
                <b-button class="shadow" block style="background-color: #5a9dbd; color: white;"  @click="createPage">Criar Página</b-button>
              </b-col>
              <b-col sm="8" offset-sm="1" v-else style="margin-top: 20px;">
                <b-button class="shadow" block style="background-color: #53514c; color: white;" disabled @click="createPage">Você só pode ter até 5 páginas.</b-button>
              </b-col>
              <b-col sm="3" style="margin-top: 20px;">
                <b-button v-if="!saving" class="shadow" block style="background-color: #77c365; color: white;"  @click="saveSiteConfiguration()">Salvar Configurações</b-button>
                <spinner v-else/>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <spinner v-else/>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";
import Spinner from "./Spinner.vue"


export default {
  name: 'SiteHome',
  data () {
    return {
      isMobile: isMobile,
      availableTemplates: [],
      selectedTemplate: undefined,
      siteConfiguration: {},
      errorMessage: "",
      pages: [],
      me: {},
      customDomainMessage: "",
      showCustomDomainModal: false,
      pageToRemove: undefined,
      showRemovePageModal: false,
      loaded: false,
      saving: false
    }
  },
  computed: {

  },
  methods: {
    previewPage: function(page) {
      window.open('https://sites.sleeker.com.br/' + this.siteConfiguration.slug + '/'+ page.slug , "_blank");
    },
    changeDefaultPage: function (page) {
      this.siteConfiguration.defaultPage = page._id;
      this.saveSiteConfiguration();
    },
    removePageAction: function(page) {
      this.pageToRemove = page;
      this.showRemovePageModal = true;
    },
    customDomainAction: function() {
      if (this.me && this.me.subscription && this.me.subscription.planType == "FREEPASS" && !this.me.subscription.isExpired) {
        this.customDomainMessage = ("Por ser cliente FREE PASS você tem direito a usar seu domínio personalizado. Entre em contato com o Suporte para fazer a configuração.");
      } else {
        this.customDomainMessage = ("Para usar seu domínio personalizado você precisa ser cliente FREE PASS.");
      }

      this.showCustomDomainModal = true;
    },
    openDemo: function(template) {
      window.open("https://sites.sleeker.com.br/" + template.demo, "_blank");
    },
    selectTemplate: function(template) {
      this.siteConfiguration.siteTemplateId = template._id;
      this.selectedTemplate = template;
    },
    removePage: function (page) {
      let vm = this;
      this.showRemovePageModal = false;
      service.removeSitePage(page._id).then(result => {
        service.getSiteByUserId(vm.me._id).then(function(result) {
          if (result.site) {
            vm.pages = result.pages;
          }
        });
      });
    },
    editPage: function (page) {
      this.$router.push('/site/page/' + page._id);
    },
    createPage: function () {
      this.saveSiteConfiguration().then(() => {
        this.$router.push('/site/page');
      }).catch(() => {

      })
    },
    saveSiteConfiguration: function() {
      this.saving = true;
      return new Promise((resolve, reject) => {
        if (this.siteConfiguration.whatsapp) {
          this.siteConfiguration.whatsapp = this.siteConfiguration.whatsapp.replace(/ /g,'');
        }

        service.saveSiteConfiguration(this.siteConfiguration).then(result => {
          this.errorMessage = "";
          this.siteConfiguration = result.site;
          this.saving = false;
          resolve();
        }).catch(error => {
          this.saving = false;
          if (error && error.message) {
            this.errorMessage = error.message;
          } else {
            this.errorMessage = "Houve um erro. Por favor, tente novamente ou procure o suporte.";
            alert(error.message);
          }
          reject(error);
        });
      });
    },
    getThumbnail(page) {
      if (page.thumbnail) {
        if (page.thumbnail.length < 200) {
          return page.thumbnail;
        } else {
          return `data:image/png;base64,${page.thumbnail}`;
        }
      } else {
        return undefined;
      }
    }
  },
  created() {
    let vm = this;

    service.getMe().then(function(me) {
        vm.me = me;
        service.getSiteByUserId(me._id).then(function(result) {
          if (result.site) {
            vm.siteConfiguration = result.site;
            vm.pages = result.pages;
            vm.selectedTemplate;
            vm.loaded = true;
          } else {
            vm.siteConfiguration = {
              slug: "",
              instagram: "",
              whatsapp: "",
              email: "",
              idUser: me._id,
              metaData: ""
            }
            
            vm.loaded = true;
          }
        });

        service.getAvailableSiteTemplates().then(result => {
          vm.availableTemplates = result.availableTemplates;

          if (vm.siteConfiguration && vm.siteConfiguration.siteTemplateId) {
            for (let key in vm.availableTemplates) {
              if (vm.availableTemplates[key]._id == vm.siteConfiguration.siteTemplateId) {
                vm.selectedTemplate = vm.availableTemplates[key];
                break;
              }
            }
          }
        });
    });
  },
  components: {Spinner}
}
</script>

<style lang="scss" scoped>
  @media (max-width: 600px) {
      .site {
        font-size: 2.3vw;
      }
  }
</style>
